export const config = window.appConfig



// WEBPACK FOOTER //
// ./web/static/js/config.js